module.exports = __webpack_public_path__ + "img/notification-success.1e7ff1e9.svg";